<template>
    <div>
       <v-card>
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12" >
                <span style="font-size:16px;font-weight:400;padding-right:15px;">Turnaround for campaigns - Filter by</span>
                <v-btn-toggle small v-model="toggle_filter" dense color="info">
                  <v-btn @click="monthlyClick(name)">
                    Monthly
                  </v-btn>

                  <v-btn @click="quartelyClick(name)">
                    Quartely
                  </v-btn>

                  <v-btn @click="yearlyClick(name)">
                    Yearly
                  </v-btn>

                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin-top:20px;">
              <v-col cols="12" sm="12" md="9" lg="9" >
                <canvas :id="name" width="500" height="200" ></canvas>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin-top:20px;margin-bottom:20px;">
              <v-col cols="12" align="end" sm="12" md="9" lg="9" >
                <v-btn color="info" @click="detailClick(name)">Details</v-btn>
              </v-col>           
            </v-row>
          </v-card-text>
       </v-card>
    </div>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: 'Bar-Chart',
  props: ['chartData', 'name'],
  data() {
    return {
      toggle_filter: 0,
      MONTHLY_DATA: [],
      cogs: ''
    }
  },
  mounted() {
    // this.renderChart(this.chartData.MONTHLY)
    setTimeout(() => {
      this.loadCharts()
    }, 1000)
  },
  methods: {
    async loadCharts() {
      let data = await this.chartData
      if (this.name === 'speed') {
        this.renderSpeedChart(data.MONTHLY)
      } else {
        this.renderSpendChart(data.MONTHLY)
      }
    },
    detailClick(name) {
      if (name === 'speed') this.$router.push({name: 'co-speed'})
      else this.$router.push({name: 'co-spend-revenue'})
    },
    monthlyClick(name) {
      if (name.toLowerCase() === 'speed') {
        this.renderSpeedChart(this.chartData.MONTHLY)
      } else this.renderSpendChart(this.chartData.MONTHLY)
    },
    quartelyClick(name) {
      if (name.toLowerCase() === 'speed') {
        this.renderSpeedChart(this.chartData.QUARTELY)
      } else this.renderSpendChart(this.chartData.QUARTELY)
    },
    yearlyClick(name) {
      if (name.toLowerCase() === 'speed') {
        this.renderSpeedChart(this.chartData.YEARLY)
      } else this.renderSpendChart(this.chartData.YEARLY)
    },
    renderSpeedChart(chartData) {
      var ctx = document.getElementById(this.name);

      const config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.speedChart !== undefined) {
        window.speedChart.destroy()
      }
      // eslint-disable-next-line
      window.speedChart = new Chart(ctx, config)
    },
    renderSpendChart(chartData) {
      var ctx = document.getElementById(this.name);

      const config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][tooltipItem['datasetIndex']]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            },
            yAxes: [{
              ticks: {
                callback: function (value) {
                  return value + '%';
                }
              },
              scaleLabel: {
                display: true,
                labelString: 'Percentage'
              }
            }]
          }
        }
      };
      if (window.spendChart !== undefined) {
        window.spendChart.destroy()
      }
      // eslint-disable-next-line
      window.spendChart = new Chart(ctx, config)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Bar.vue?475035f6